@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.core.ui.component.connectivity_monitor.util

import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import org.w3c.dom.events.Event

actual class ConnectivityMonitor actual constructor(platformContext: Any?) {
    private val _status = MutableStateFlow(ConnectivityMonitorStatus.UNKNOWN)
    actual val status: StateFlow<ConnectivityMonitorStatus> = _status

    private val onOnline: (Event) -> Unit =
        { _ -> _status.tryEmit(ConnectivityMonitorStatus.CONNECTED) }
    private val onOffline: (Event) -> Unit =
        { _ -> _status.tryEmit(ConnectivityMonitorStatus.DISCONNECTED) }


    actual fun start() {
        val initial = try {
            if (js("navigator.onLine") as Boolean) ConnectivityMonitorStatus.CONNECTED else ConnectivityMonitorStatus.DISCONNECTED
        } catch (_: Throwable) {
            ConnectivityMonitorStatus.UNKNOWN
        }
        _status.tryEmit(initial)
        window.addEventListener("online", onOnline)
        window.addEventListener("offline", onOffline)
    }

    actual fun stop() {
        window.removeEventListener("online", onOnline)
        window.removeEventListener("offline", onOffline)
    }
}
